import React from "react";

import "./styles.scss";

export enum INotificationType {
  ERROR = "notification_error",
  SUCCESS = "notification_success",
  NONE = ""
}

interface INotificationProps {
  type: INotificationType;
  message: string;
}

export const Notification: React.FC<INotificationProps> = props => {
  return (
    <div className={`notification ${props.type}`}>
      <p>{props.message}</p>
    </div>
  );
};
